
export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-amber-600 via-orange-500 to-amber-600 text-white py-12 mt-20">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-bold mb-4">Cookie Clicker</h3>
            <p className="text-sm text-amber-100">The most addictive cookie clicking game on the internet. Start baking now!</p>
          </div>
          <div>
            <h4 className="text-base font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#game" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Play Game</a></li>
              <li><a href="#leaderboard" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Leaderboard</a></li>
              <li><a href="#achievements" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Achievements</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-semibold mb-4">Community</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#discord" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Discord</a></li>
              <li><a href="#reddit" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Reddit</a></li>
              <li><a href="#twitter" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Twitter</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#faq" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">FAQ</a></li>
              <li><a href="#contact" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact Us</a></li>
              <li><a href="#privacy" className="text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-amber-400/30 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-amber-100">© 2025 Cookie Clicker. All cookies reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Website Builder</a>
        </div>
      </div>
    </footer>
  );
}
